import NewConcessionRequest from './NewConcessionRequest';

export default NewConcessionRequest;
